import React from 'react';
import { __ } from '@wordpress/i18n';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

// store
import { useStoreValue } from '../../store';

// components
import ModalModifyTeam from '../ModalModifyTeam';
import ProjectMember from './components/ProjectMember';

const WidgetTeam = ({ projectId }) => {
    const team = useStoreValue('team');

    return(
        <div className="WidgetTeam">
            <div className="WidgetTeam__header">
                <h3 className="WidgetTeam__title">
                    {__('Team', 'soundbetween')}
                </h3>
                <div className="WidgetTeam__actions">
                    <span className="WidgetTeam__quantity">{team.length}</span>
                    <ModalModifyTeam projectId={projectId}/>
                </div>
            </div>
            <OverlayScrollbarsComponent element="div" className="WidgetTeam__body" options={{ scrollbars: { autoHide: 'never' } }} defer>
                {team.map(o => <div key={o.id} className="WidgetTeam__bodyItem">
                    <ProjectMember data={o}/>
                </div>)}
            </OverlayScrollbarsComponent>
        </div>
    )
}

export default WidgetTeam;